module.exports = "../../static/img/Path备份.7d133c4.svg";